import Vue from 'vue';
import Vuetify, { VImg, VHover, VList, VListItem, VMenu, VSwitch, VApp } from 'vuetify/lib';
// import {  } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
    components: {
        VImg,
        VHover,
        VList,
        VListItem,
        VMenu,
        VSwitch,
        VApp
      },
      directives: {
        
      },
});

export default new Vuetify({
});
